import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './Location.scss';

import { PulseLocationState } from '../../../models/Models';
import { ADAARIARoles, ADALandmarks, ADAWidgitRoles } from '../../../models/ADA';

const Location = ({ location, activeKey, onSelected, isActive}) => {
    const menuOpened = useSelector(state => state.data.menuOpened);

    var state = PulseLocationState.Waiting;
    if(activeKey >= 0){
        if(activeKey === location.Key){
            state = PulseLocationState.Active;
        } else {
            state = PulseLocationState.Inactive;
        }
    }

    const handleOnClick = event => {
        onSelected((state !== PulseLocationState.Active)?location.Key:-1);
    };
    
    let locationClass = (state === PulseLocationState.Active)?"location active":(state === PulseLocationState.Inactive)?"location inactive":"location waiting";

    return (
        <div tabIndex={(isActive && !menuOpened) ? 0 : -1} role={ADAWidgitRoles.Button} className={locationClass}
            onKeyUp={(e) => {
            if (e.key === 'Enter') {
              handleOnClick();
            }
          }}
            onClick={handleOnClick}>
            <div className="divider"/>
            <div className="location-text">
                {location.Name}
            </div>
        </div>
    );
};

export default Location;
